import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push, replace, goBack } from 'react-router-redux';
import compact from 'lodash/compact';
import omit from 'lodash/omit';
import moment from 'moment-timezone';
import seo from 'shared/lib/seo';
import * as analytics from 'shared/lib/analytics';
import Toast from '../../components/Toast';
import TopNavBar from '../../components/TopNavBar';
import {
  startRentalCarExtension,
  getRentalCarExtensionPolicy,
  updateRentalCarExtensionConfirmationNumber,
  getRentalCarExtensionCheckout,
  purchaseRentalCarExtension,
  showMenu,
  hideMenu,
  hideToast,
} from '../../store/actions';
import api from '../../api';
import withSubapp from 'shared/lib/apps/RentalCarApp/hoc';
import withGlobals from '../../withGlobals';

class RentalCar extends Component {
  componentDidMount() {
    seo.setProps({
      title: 'Car Rental Insurance & Rental Car Protection | Sure',
      description:
        'Get Rental Car Insurance through Sure to protect your rental during your travels. Plans starting at $10/day.',
      url: 'https://www.sureapp.com/rental-car-insurance',
    });
  }

  render() {
    return (
      <div className="RentalCar">
        {compact(this.props.location.pathname.split('/')).length > 1 && (
          <TopNavBar
            isLoggedIn={this.props.isLoggedIn}
            userFullName={this.props.userFullName}
            isMenuOpen={this.props.isMenuOpen}
            activeLink={this.props.location.pathname}
            isFixed
            onHideMenu={this.props.hideMenu}
            onShowMenu={this.props.showMenu}
          />
        )}
        {React.cloneElement(
          this.props.children,
          omit(this.props, ['children'])
        )}
        {this.props.toast && (
          <Toast
            message={this.props.toast.message}
            sureStyle={this.props.toast.style}
            onDismiss={this.props.hideToast}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    // Base
    isLoggedIn: !!state.authToken,
    userFullName: `${state.account.firstName} ${state.account.lastName}`,
    isMenuOpen: state.isMenuOpen,
    toast: state.toast,
    account: state.account,
    isRentalCarInProgress: state.isRentalCarInProgress,
    // Extension
    extensionReturnDate:
      state.rentalCarExtensionReturnDate &&
      moment(state.rentalCarExtensionReturnDate),
    extensionPolicy: state.rentalCarExtensionPolicy,
    extensionCheckout: state.rentalCarExtensionCheckout,
    policiesById: state.policiesById,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    goBack: () => {
      analytics.track('Rental Car - Back Button Clicked', {
        category: 'survey',
      });
      dispatch(goBack());
    },
    ...bindActionCreators(
      {
        hideMenu,
        hideToast,
        goBack,
        showMenu,
        redirect: replace,
        navTo: pathname =>
          push({
            pathname,
            query: ownProps.location.query,
          }),

        // Extension
        startRentalCarExtension: startRentalCarExtension,
        getRentalCarExtensionPolicy: getRentalCarExtensionPolicy,
        getRentalCarExtensionCheckout: getRentalCarExtensionCheckout,
        updateExtensionConfirmationNumber: updateRentalCarExtensionConfirmationNumber,
        purchaseRentalCarExtension: purchaseRentalCarExtension,
      },
      dispatch
    ),
  };
};

const enhance = compose(
  withRouter,
  withGlobals({
    analyticsPrefix: 'Rental Car',
  }),
  withSubapp(api),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
);

export default enhance(RentalCar);
